import React from 'react';
import { getKkpSurfaceStyle } from '../../utils/kkpColorUtils';

const KkpColorBadge = ({ color, children, vivid = false, className = 'badge' }) => {
  const surface = getKkpSurfaceStyle(color, { vivid });

  return (
    <span
      className={className}
      style={{
        backgroundColor: surface.backgroundColor,
        color: surface.color,
        border: '1px solid rgba(0, 0, 0, 0.06)',
      }}
    >
      {children}
    </span>
  );
};

export default KkpColorBadge;
